import { TablePagination, TablePaginationProps } from '@mui/material';

export type CustomPaginationProps = TablePaginationProps & {
  dropdownIconColor?: string;
  prevIconColor?: string;
  nextIconColor?: string;
};

export function Pagination(props: CustomPaginationProps) {
  const { dropdownIconColor, prevIconColor, nextIconColor, slotProps, ...rest } = props;
  return (
    <TablePagination
      slotProps={{
        select: {
          sx: {
            '.MuiSelect-icon': {
              color: dropdownIconColor || 'white',
            },
            '.MuiMenu-list': {
              paddingTop: 0,
              paddingBottom: 0,
            },
          },
          ...slotProps?.select,
        },
        actions: {
          previousButtonIcon: {
            sx: {
              color: prevIconColor || 'white',
            },
          },
          nextButtonIcon: {
            sx: {
              color: nextIconColor || 'white',
            },
          },
        },
        ...slotProps,
      }}
      {...rest}
    />
  );
}
